import React from 'react';
import { useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import { formatNumberWithSpaces } from 'shared/utils/common';
import { RUB, NBSP } from 'shared/constants/common';
import { InfoBlock } from '../InfoBlock';
import { PskBlock, IPskBlockProps } from '../PskBlock';
import { RateBlock } from '../RateBlock';
import styles from './styles.css';
import { formatNumberToMillionRubles } from '../../../../utils/common/formatNumberToMillionRubles';
import { IOfferRate } from '../../../../repositories/mortgage-broker-calculator/entities/mortgage_listing/OfferRate';

export interface IConditionListProps {
  limit?: number | null;
  income?: number | null;
  monthlyPayment?: number | null;
  psk?: IPskBlockProps | null;
  rate?: IOfferRate | null;
}

export const ConditionList: React.FC<IConditionListProps> = ({ psk, rate, limit, income, monthlyPayment }) => {
  const deviceType = useDeviceType();

  // Супер костыль для рендера Т-банка, это надо будет рефакторить
  if (!limit) {
    return null;
  }

  return (
    <ul className={cn(styles['list'], styles[deviceType])}>
      {psk ? (
        <li className={cn(styles['list-item'], styles[deviceType])}>
          <PskBlock to={psk.to} from={psk.from} />
        </li>
      ) : null}
      {rate ? (
        <li className={cn(styles['list-item'], styles[deviceType])}>
          <RateBlock rate={rate} />
        </li>
      ) : null}
      {limit && (
        <li className={cn(styles['list-item'], styles[deviceType])}>
          <InfoBlock title={'Лимит'} text={formatNumberToMillionRubles(limit)} />
        </li>
      )}
      {income && (
        <li className={cn(styles['list-item'], styles[deviceType])}>
          <InfoBlock title={'Доход'} text={`от${NBSP}${formatNumberWithSpaces(income)}${NBSP}${RUB}`} />
        </li>
      )}
      {monthlyPayment && (
        <li className={cn(styles['list-item'], styles[deviceType])}>
          <InfoBlock title={'Платёж'} text={`от${NBSP}${formatNumberWithSpaces(monthlyPayment)}${NBSP}${RUB}`} />
        </li>
      )}
    </ul>
  );
};
